export default __webpack_public_path__ + "static/media/antp_Incoterms_CuadroPostEvento.cd38e956.jpg";